import { create } from "zustand"

const useStorePageIndexState = create(
    (set, get) => ({
        highlightState:{
            home: true,
            about: false,
            projects: false,
            contact: false,
        },
        setHighlightState: (data) => {
            set(() => ({
                highlightState: data
            }))
        },
    })
)

export default useStorePageIndexState